import queryString from "query-string";

const makeSpotifyAPIRequest = (params) => {
  const access_token = localStorage.getItem("spotify_auth_access_token");

  if (access_token == null) {
    return;
  }

  const access_token_expiry = localStorage.getItem(
    "spotify_auth_access_token_expiry_date"
  );

  if (
    new Date().getTime() / 1000 >= access_token_expiry &&
    !params.maxTriesAttempted
  ) {
    fetch(new URL("https://accounts.spotify.com/api/token"), {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: queryString.stringify({
        client_id: "03923be55d6742998dcb4afb917fd241",
        grant_type: "refresh_token",
        refresh_token: localStorage.getItem("spotify_auth_refresh_token"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          localStorage.removeItem("spotify_auth_access_token");
          localStorage.removeItem("spotify_auth_refresh_token");
          localStorage.removeItem("spotify_auth_access_token_expiry_date");
          return;
        }

        handleSuccessfulAuthentication(
          data.access_token,
          data.refresh_token ??
            localStorage.getItem("spotify_auth_refresh_token"),
          data.expires_in
        );
        params.maxTriesAttempted = true;
        makeSpotifyAPIRequest(params);
      });

    return;
  }

  const fetchOptions = {
    method: params.method,
    headers: {
      Authorization: "Bearer " + access_token,
    },
  };

  if (params.body) {
    fetchOptions.body = JSON.stringify(params.body);
    fetchOptions.headers["Content-Type"] = "application/json";
  }

  const promise = fetch(params.url, fetchOptions).then((response) => {
    if (response.status === 204) {
      return {};
    }
    return response.json();
  });

  if (params.returnPromise) {
    return promise;
  }

  promise
    .then((data) => {
      if (Object.keys(data).length === 0) {
        params.onNoContentCallback();
        return;
      }

      if (data.error) {
        params.onFailureCallback(data);
      } else {
        params.onSuccessCallback(data);
      }
    })
    .catch((err) => {
      console.error("Spotify API request failed:", err);
    });
};

const handleSuccessfulAuthentication = (
  access_token,
  refresh_token,
  expires_in
) => {
  if (access_token == null || refresh_token == null || expires_in == null) {
    return;
  }

  localStorage.setItem("spotify_auth_access_token", access_token);
  localStorage.setItem("spotify_auth_refresh_token", refresh_token);
  localStorage.setItem(
    "spotify_auth_access_token_expiry_date",
    new Date().getTime() / 1000 + expires_in
  );
  localStorage.removeItem("spotify_auth_code_verifier");
  localStorage.removeItem("spotify_auth_state");

  const url = "https://api.spotify.com/v1/me";

  makeSpotifyAPIRequest({
    url: url,
    method: "GET",
    onSuccessCallback: (data) => {
      if (data.id !== "thunderchunder") {
        localStorage.removeItem("spotify_auth_access_token");
        localStorage.removeItem("spotify_auth_refresh_token");
      }

      localStorage.setItem("spotify_user_id", data.id);
    },
  });
};

const makePlayerRequest = (url, method, callback) => {
  makeSpotifyAPIRequest({
    url: url,
    method: method,
    onSuccessCallback: () => {},
    onNoContentCallback: callback,
  });
};

const getAlbumArtURLFromImages = (images) => {
  if (!images) {
    return null;
  }

  for (const image of images) {
    if (image.height === 300) {
      return image.url;
    }
  }
};

const updatePlaylistsForSong = (
  songID,
  playlistIDAdd,
  playlistIDRemove,
  allRemoveTrackIDs
) => {
  const removeIDs = allRemoveTrackIDs ?? [songID];
  playlistIDRemove.forEach((playlistID) => {
    const url = new URL(
      `https://api.spotify.com/v1/playlists/${playlistID}/tracks`
    );
    makeSpotifyAPIRequest({
      url: url,
      method: "DELETE",
      body: {
        tracks: removeIDs.map((id) => {
          return { uri: "spotify:track:" + id };
        }),
      },
      onSuccessCallback: () => {},
      onFailureCallback: () => {},
    });
  });

  playlistIDAdd.forEach((playlistID) => {
    const url = new URL(
      `https://api.spotify.com/v1/playlists/${playlistID}/tracks`
    );
    makeSpotifyAPIRequest({
      url: url,
      method: "DELETE",
      body: {
        tracks: removeIDs.map((id) => {
          return { uri: "spotify:track:" + id };
        }),
      },
      onSuccessCallback: () => {
        const url = new URL(
          `https://api.spotify.com/v1/playlists/${playlistID}/tracks`
        );
        makeSpotifyAPIRequest({
          url: url,
          method: "POST",
          body: {
            uris: ["spotify:track:" + songID],
          },
          onSuccessCallback: () => {},
          onFailureCallback: () => {},
        });
      },
      onFailureCallback: () => {},
    });
  });
};

export {
  handleSuccessfulAuthentication,
  makeSpotifyAPIRequest,
  makePlayerRequest,
  getAlbumArtURLFromImages,
  updatePlaylistsForSong,
};
